import { css } from 'linaria';

export const productCardsSectionTextWrapper = css`
  width: 776px;
  margin-bottom: 24px;

  @media (--only-desktop) {
    width: 616px;
  }

  @media (--to-desktop) {
    width: 100%;
  }
`;
